<template>
  <div class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 backdrop-blur-[4px]" @click.self="$emit('close')">
    <div class="bg-n-background rounded-2xl shadow-2xl w-full max-w-md flex flex-col">
      <div class="px-6 py-5 border-b border-n-weak">
        <h2 class="text-lg font-extrabold text-n-slate-12">Compartilhar tarefa</h2>
      </div>
      <div class="px-6 py-4 space-y-3">
        <p class="text-sm text-n-slate-11">Gere um link publico read-only desta tarefa.</p>
        <div v-if="shareUrl" class="flex gap-2">
          <input readonly :value="shareUrl" class="flex-1 px-3 py-2 rounded border border-n-strong bg-n-alpha-2 text-xs" />
          <button class="px-3 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white text-xs" @click="copy">Copiar</button>
        </div>
        <div class="flex gap-2 pt-2">
          <button v-if="!shareUrl" class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm font-medium" @click="generate">Gerar link</button>
          <button v-if="shareUrl" class="px-4 py-2 bg-red-50 hover:bg-red-100 text-red-600 rounded text-sm font-medium" @click="revoke">Revogar link</button>
        </div>
      </div>
      <div class="px-6 py-3 border-t border-n-weak flex justify-end">
        <button class="px-4 py-1.5 text-sm rounded-xl bg-n-alpha-2 hover:bg-slate-200 text-n-slate-11" @click="$emit('close')">Fechar</button>
      </div>
    </div>
  </div>
</template>


<script>
import { useAlert } from 'dashboard/composables';
import TaskShareAPI from 'dashboard/api/taskShare';

export default {
  name: 'TaskShareDialog',
  props: { taskId: { type: Number, required: true }, initialUrl: { type: String, default: '' } },
  emits: ['close', 'changed'],
  data() { return { shareUrl: this.initialUrl }; },
  methods: {
    async generate() {
      try {
        const { data } = await TaskShareAPI.generate(this.taskId);
        this.shareUrl = data.public_url || (window.location.origin + '/public/tasks/' + data.public_token);
        this.$emit('changed', { public_url: this.shareUrl, public_token: data.public_token });
        useAlert('Link gerado');
      } catch (e) { useAlert('Erro ao gerar link'); }
    },
    async revoke() {
      if (!window.confirm('Revogar link?')) return;
      try {
        await TaskShareAPI.revoke(this.taskId);
        this.shareUrl = '';
        this.$emit('changed', { public_url: '', public_token: null });
        useAlert('Revogado');
      } catch (e) { useAlert('Erro ao revogar'); }
    },
    copy() { if (this.shareUrl) { navigator.clipboard?.writeText(this.shareUrl); useAlert('Copiado'); } },
  },
};
</script>

